module.exports = __webpack_public_path__ + "static/media/meals-admin.9a0cd792.svg";